import apiPath from '../../../config/api';

const DailySumPath = {
    title: "Toko Material - Laporan Rekap Penjualan",
    basePath: "/material/rekap-penjualan",
    base: apiPath.retailDailySum,
}

export default DailySumPath;
